import React from 'react';
import AllocationBlock from './AllocationBlock';
import moment from 'moment';
import { deleteCollectionWills, getStateHeadingData } from '../../api/api';
import { setBeneficiary } from '../../actions/beneficiary';
import { getStateHeadings } from '../../actions/Dashboard';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Modal } from '../Common';
import { pushToDataLayer } from '../../utils/gtmUtils';


export class DashboardPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      disabled: false,
      disabledDeleteButton: false,
      displayModal: 'inactive',
      displayConnexion: props.beneficiary && props.beneficiary.displayConnexion,
      displayDeleteMessage: 'init',
      conventionAssistanceText: "Avant de commencer à saisir vos volontés, vous devez autoriser "+ this.props.partenaireData.marqueAllianzPartners +" à conserver vos données, à les restituer à votre chargé de mémoire et à mettre en œuvre les prestations d'assistance annoncées dans la convention."
    }
  }

  componentWillMount() {
    if (this.props.beneficiary && this.props.beneficiary.idBeneficiaire)
      getStateHeadingData(this.props.beneficiary.idBeneficiaire, this.props.partenaireData.id, sessionStorage.defaultID).then((response) => {
        this.props.getStateHeadings(response.data);
      });
  }



  deleteCollectionWillss = () => {
    const dataLayer = {
      event: "deleteCollectionWills",
      url: window.location.href,
      idPartenaire: this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);
    deleteCollectionWills(this.props.beneficiary.idBeneficiaire, this.props.partenaireData.id).then((response) => {
      getStateHeadingData(this.props.beneficiary.idBeneficiaire, this.props.partenaireData.id, sessionStorage.defaultID).then((response) => {
        this.props.getStateHeadings(response.data);
      });
      this.setState({ displayDeleteMessage: 'hidden' });
      this.closeModal();
    })
  };

  componentDidUpdate(prevProps) {
    if (prevProps.stateHeadingsData !== this.props.stateHeadingsData) {
      const disabled = _.find(this.props.stateHeadingsData, { state: false }) ? true : false;
      const disabledDeleteButton = _.find(this.props.stateHeadingsData, { state: true }) ? false : true;
      this.setState({
        disabled,
        disabledDeleteButton,
        displayConnexion: this.props.beneficiary.displayConnexion
      });
    }
  }

  pushToDataLayer = (event) => {
    const dataLayer = {
      "event": event,
			"url": window.location.href,
			"idPartenaire": this.props.partenaireData.id
    }
    pushToDataLayer(dataLayer);
  }

  sendCollectionWillss = () => {
    this.props.history.replace('/recap-recueil');
  };

  closeLastLogin = () => {
    this.setState({ displayConnexion: false });
    this.props.setBeneficiary({ displayConnexion: false });
  }

  closeModal = () => {
    this.setState({ displayModal: 'inactive' });
    window.scrollTo(0, 0);
  }
  openModal = () => {
    this.setState({ displayModal: 'active' });
    window.scrollTo(0, 0);
  }
  hideDeleteMessage = () => {
    this.setState({ displayDeleteMessage: 'init' });
  }

  render() {

    const allocationList = [
      {
        title: "Ma convention d\'assistance",
        id: 1,
        status: false,
        code: "CONVENTION_ASSISTANCE",
        img: 'b1-lg.png',
        sm: 'b1-page-sm.png',
        text: this.state.conventionAssistanceText,
        link: 'convention-obseques',
        gtmEventAcces: 'assistanceAgreementInit',
        gtmEventUpdate: 'assistanceAgreementUpdate'
      },
      {
        title: 'Mes chargés de mémoire',
        id: 2,
        status: false,
        code: "CHARGE_MEMOIRE",
        img: 'b2-lg.png',
        sm: 'b2-page-sm.png',
        text: 'Désignez dès maintenant les personnes qui devront respecter vos volontés.',
        link: 'charges-de-memoire',
        gtmEventAcces: 'memoryChargedInit',
        gtmEventUpdate: 'memoryChargedUpdate'
      },
      {
        title: 'Mes obsèques',
        id: 3,
        code: "PDV_POST_MORTEM",
        status: false,
        img: 'b3-lg.png',
        sm: 'mes-obs-sm.png',
        text: `Pour que vos proches sachent ce que vous souhaitez pour vos funérailles,
         indiquez dès maintenant ce que vous voulez pour la cérémonie et pour les soins de conservation.`,
        link: 'mes-obseques',
        gtmEventAcces: 'funeralInit',
        gtmEventUpdate: 'funeralUpdate'
      },
      {
        title: 'Mes informations juridiques',
        id: 4,
        code: "INFO_JURIDIQUE",
        status: false,
        img: 'b4-lg.png',
        sm: 'i-j-sm.png',
        text: `Afin que vos dernières volontés soient respectées, informez vos proches si vous avez rédigé un testament ; qu’il soit olographe (rédigé par vous-même) ou authentique (rédigé par un notaire).`,
        link: 'informations-juridiques',
        gtmEventAcces: 'legalInformationInit',
        gtmEventUpdate: 'legalInformationUpdate'
      },
      {
        title: 'Mon avis de décès',
        id: 5,
        code: "AVIS_DECES",
        status: false,
        img: 'b5-lg.png',
        sm: 'avis-deces-sm.png',
        text: `Vous pouvez, si vous le souhaitez, rédiger le texte de votre avis de décès et indiquer 
        le(s) media(s) dans lesquels le diffuser. Indiquez également 
        à votre chargé de mémoire les personnes et les organismes qui doivent être informés de votre décès.`,
        link: 'avis-deces',
        gtmEventAcces: 'deathNoticeInit',
        gtmEventUpdate: 'deathNoticeUpdate'
      },
    ]

    return (
      <div>
        <div className={"delete-msg " + this.state.displayDeleteMessage}>
          <div className="content">
            <img src="/images/delete-msg.png" />
            <p>Votre recueil de mémoire a été supprimé définitivement.</p>
            <button type="button" className="btn btn-primary btn-ok" onClick={this.hideDeleteMessage}>OK</button>
          </div>
        </div>
        <div className={"dashboard-page " + this.state.displayDeleteMessage}>
          <Modal status={this.state.displayModal}>
            <div onClick={this.closeModal} className="close">X</div>
            <img src="/images/delete-modal.png" />
            <p>Vous êtes sur le point d'effacer définitivement votre recueil de mémoire. Vouler-vous vraiment le supprimer</p>
            <div className="button-container">
              <button type="button" className="btn btn-outline-primary" onClick={this.closeModal}>ANNULER</button>
              <button type="button" className="btn btn-primary" onClick={this.deleteCollectionWillss}>Supprimer</button>
            </div>
          </Modal>
          <div className="intro">
            <h1>Mon recueil de mémoire</h1>
            {/* <img src="/images/banner.png" alt="block name" className="img-banner img-thumbnail" /> */}
            <div className="intro-text">
              En souscrivant un contrat Obsèques, vous avez souhaité ne rien laisser au hasard concernant vos obsèques.
               Ainsi, vous soulagez vos proches du poids de l'organisation d'un enterrement.
               Ce site de recueil de volontés vous donne la possibilité de mentionner toutes vos volontés essentielles pour le jour de vos obsèques.
      </div>
          </div>
          {this.state.displayConnexion && this.props.beneficiary.lastSuccessLogin &&
            <div className="last-login">Votre dernière connexion a été effectuée le
          {moment(this.props.beneficiary.lastSuccessLogin).utc().format(' dddd Do MMMM YYYY à HH:mm ')}
              <div onClick={this.closeLastLogin} className="close">X</div>
            </div>
          }
          <div className="container main-container">
            <div className="home-paragraph">
              Compléter les différentes rubriques du recueil pour que vos volontés soient sauvegardées.
              Vous pouvez modifier ces informations à tout moment.
        </div>
            <div className="set-memory-container">
            <p> Pour envoyer votre recueil de mémoire définitif à {this.props.partenaireData.marqueAllianzPartners}, il est nécessaire de compléter toutes
            les rubriques ci-dessous. Une rubrique est complétée intégralement lorsque le pictogramme vert <img src='/images/check-copy.png' alt='pictogramme vert' width="20" height="20"/> est présent sur la rubrique.
            </p>
            <p>Vous pouvez supprimer votre recueil de mémoire à tout moment. Les informations préalablement saisies ne seront
            alors plus disponibles et vous devrez créer un nouveau recueil.</p>
              <div className="button-container">
                <button type="button" className="btn btn-light" onClick={this.openModal} disabled={this.state.disabledDeleteButton}>Supprimer le recueil de memoire</button>
                <button type="button" className="btn btn-primary" onClick={this.sendCollectionWillss} disabled={this.state.disabled}>Envoyer le recueil de memoire</button>
              </div>
            </div>
            <div className="allocations" ref="allocations">
              <div className="row">
                {/*this.state && this.state.data ?*/

                  allocationList.map((item, i) =>
                    <AllocationBlock

                      status={this.props.stateHeadingsData && this.props.stateHeadingsData[0] ? this.props.stateHeadingsData.find(x => x.code === item.code).state : ''}
                      key={i}
                      data={item}
                      index={i} 
                      pushToDataLayer={this.pushToDataLayer}/>
                  )
                  //:
                  // <Loader />
                }
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

}

const mapStateToProps = state => {
  return {
    beneficiary: state.beneficiaryData.idBeneficiaire ? state.beneficiaryData : JSON.parse(sessionStorage.getItem('benef')),
    user: state.auth,
    stateHeadingsData: state.stateHeadingsData.rubriques,
    partenaireData: state.partenaireData
  }
};

const mapDispatchToProps = (dispatch) => ({
  setBeneficiary: (data) => dispatch(setBeneficiary(data)),
  getStateHeadings: (data) => dispatch(getStateHeadings(data)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DashboardPage);





// WEBPACK FOOTER //
// ./src/components/DashboardPage/DashboardPage.js